import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Section } from './ui/Section';
const faqs = [{
  q: '¿Es difícil de configurar?',
  a: 'Si sabés usar Gmail y completar un formulario, podés hacerlo. No requiere conocimientos previos de programación ni código.'
}, {
  q: '¿Qué herramientas necesito?',
  a: 'Usamos Zapier, Make y Typeform. Podés empezar con versiones gratuitas de todas estas plataformas sin problema.'
}, {
  q: '¿Sirve para Argentina?',
  a: 'Sí, está adaptado para cobrar con las pasarelas que usamos acá (MercadoPago, transferencias) y en el exterior (Stripe, PayPal).'
}, {
  q: '¿Cuánto tiempo me lleva ver resultados?',
  a: 'Podés tener tu primera automatización funcionando en menos de 60 minutos si seguís el paso a paso del Blueprint.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section className="px-6 md:px-12 max-w-3xl mx-auto border-t border-[#d4a853]/10" data-id="element-110">
      <div className="text-center mb-12" data-id="element-111">
        <h2 className="font-serif text-3xl md:text-4xl font-semibold text-gray-100" data-id="element-112">
          Preguntas Frecuentes
        </h2>
      </div>

      <div className="space-y-4" data-id="element-113">
        {faqs.map((faq, i) => {
        const isOpen = openIndex === i;
        return <div key={i} className={`border transition-colors duration-300 ${isOpen ? 'border-[#d4a853]/50 bg-[#111827]/50' : 'border-gray-800 bg-[#0a0a0a] hover:border-gray-700'}`} data-id="element-114">
              <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-115">
                <span className={`font-serif text-lg md:text-xl transition-colors ${isOpen ? 'text-[#f0c674]' : 'text-gray-200'}`} data-id="element-116">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: isOpen ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-117">
                  <ChevronDown className={`w-5 h-5 ${isOpen ? 'text-[#d4a853]' : 'text-gray-500'}`} data-id="element-118" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-119">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-120">
                    <div className="p-6 pt-0 font-sans text-gray-400 leading-relaxed" data-id="element-121">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </Section>;
}